export default () => ({
  isListenerActive: false,
  disableContextMenu: false,
})
